import { useContext } from 'react';
import { PreviewContext } from './context';
/**
 * @deprecated This hook is to be deprecated
 * If you need the document ID use `useActiveDocument` instead.
 * If you need data about the document, query it where needed.
 */
export const usePreview = () => useContext(PreviewContext);
export const useActiveDocument = () => {
    const { id, name, company } = useContext(PreviewContext);
    return {
        id,
        name,
        company,
    };
};
